import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  constructor() {}

  downloadFileFromBlobObject(blob: Blob, filename: string): void {
    const a: HTMLAnchorElement = document.createElement('a');
    const objectUrl: string = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(objectUrl);
  }

  extractFileNameFromContentDispositionHeader(res: HttpResponse<Blob>): string {
    return (
      res.headers.get('content-disposition')?.split('; ')[1].split('=')[1].replace(/['"]/g, '') ??
      'unknown'
    );
  }
}
